<template>
<u-plot-stacked
    ref="plot"
    v-if="plotData.length"
    :data="plotData"
    :series="plotSeries"
    :dark="$vuetify.theme.dark"
    duration
/>
</template>

<script>
import iso8601Duration from '@/services/iso8601Duration.js';
import uPlotStacked from '@/components/uPlotStacked.vue';

export default {
    props: {
        value: {type: Object, required: false},
        attrs: {type: Object, required: true}
    },
    data () { return {
        steptypes: {
            ramp_temp_vib: this.$t('Temp & Vibe Ramp'),
            ramp_temp: this.$t('Temp Ramp'),
            ramp_vib: this.$t('Vibe Ramp'),
            dwell: this.$t('Dwell'),
            goto: this.$t('Go To Step')
        }
    }},
    components: { uPlotStacked },
    computed: {
        formatLabel () { return (group, key) => this.$style.label.short(key, 'short'); },
        plotData () {
            const rtn = [];
            const lp_prog = (lp, now, total) => lp.start + ((lp.end - lp.start) * (1 - ((total - now) / total)));
            try {
                const hasVib = !!(this.attrs && this.attrs.vib);
                const suplStart = hasVib ? 3 : 2;
                const dt = 0, tmp = 1, vib = 2, stp = suplStart, typ = suplStart + 1, goto=suplStart + 2, ts = suplStart + 3;
                //let time = Math.floor(Number(new Date())/1000);
                let time = 0;
                const count = hasVib ? 13 : 12;
                for (let i = 0; i <= count; i++)
                    rtn.push([]);
                let myusr = [false, false, false, false,   false, false, false, false];
                let usrt = 0;
                this.value.steps.forEach((s, i) => {
                    if (s.type === 'goto') {
                        const mystr = `(${s.goto.step+1}\uD83D\uDDD8${i+1})*${s.goto.count}`
                        const gotos = rtn[goto];
                        for (let d = 0; d < gotos.length; d++) {
                            if (rtn[stp][d] > s.goto.step && rtn[stp][d] < i + 1) {
                                gotos[d] += gotos[d] != '' ? `, ${mystr}` : mystr;
                            }
                        }
                        return;
                    }
                    let usri = 0, now = 0;
                    const vibt = hasVib ? iso8601Duration.toSeconds(s.vib.duration) : 0;
                    const tempt = iso8601Duration.toSeconds(s.temp.duration);
                    const totaltime = Math.max(tempt, vibt);
                    usrt = s.usr.length ? iso8601Duration.toSeconds(s.usr[usri].time) : Infinity;
                    while (now <= totaltime) {
                        rtn[dt].push(time + now);
                        rtn[goto].push('');
                        rtn[tmp].push(now < tempt ? lp_prog(s.temp, now, tempt) : s.temp.end);
                        if (hasVib)
                            rtn[vib].push(now < vibt ? lp_prog(s.vib, now, vibt) : s.vib.end);
                        rtn[stp].push(i+1);
                        rtn[typ].push(this.steptypes[s.type]);
                        if (usri < s.usr.length && now >= usrt) {
                            myusr = s.usr[usri].values;
                            usri++;
                            usrt = usri < s.usr.length ? iso8601Duration.toSeconds(s.usr[usri].time) : Infinity;
                        }
                        for (let t = 0; t < 8; t++)
                            rtn[ts+t].push(myusr[t]);
                        let vibr = Infinity;
                        if (hasVib) {
                            vibr = vibt - now;
                            vibr = vibr > 0 ? vibr : Infinity;
                        }
                        let tempr = tempt - now;
                        tempr = tempr > 0 ? tempr : Infinity;
                        let usrr = usrt - now;
                        usrr = usrr > 0 ? usrr : Infinity;
                        now += Math.min(vibr, tempr, usrr);
                    }
                    time += totaltime;
                });
            } catch (error) {
                console.warn(error);
            }
            return rtn;
        },
        plotSeries () { 
            const rtn = [
                {
                    "col": "temp__set_value", 
                    "ptype": "num",
                    "label": this.$style.label.short('temp__set_value'),
                    "stroke": "#7f0000",
                    "width": 2,
                    "show": true,
                    "units": "°C",
                    points: {show: false}
                }
            ];
            if (this.attrs.vib) {
                rtn.push({
                    "col": "vib__set_value",
                    "ptype": "num",
                    "label": this.$style.label.short('vib__set_value'),
                    "stroke": "#800CBD",
                    "width": 2,
                    "show": true,
                    "units": "G",
                    points: {show: false}
                });
            }
            rtn.push(...[
                {
                    "col": "step",
                    "ptype": "state",
                    "label": this.$t("Step"),
                    "stroke": {},
                    "points": false,
                    "width": 1,
                    "show": true,
                    "dash": [],
                    i18n: v => v
                },
                {
                    "col": "type",
                    "ptype": "state",
                    "label": this.$t("Type"),
                    "stroke": {},
                    "points": false,
                    "width": 1,
                    "show": true,
                    "dash": [],
                    i18n: v => v
                },
                {
                    "col": "goto",
                    "ptype": "state",
                    "label": this.$t("Go To"),
                    "stroke": {'': 'black'},
                    "points": false,
                    "width": 1,
                    "show": true,
                    "dash": [],
                    i18n: v => v
                }
            ]);
            for (let i = 1; i <= 8; i++) {
                rtn.push({
                    "col": `time_signal_${i}`,
                    "ptype": "bool",
                    "label": this.formatLabel('output', `time_signal_${i}`),
                    "stroke": {'false': 'black'},
                    "points": false,
                    "width": 1,
                    "show": true,
                    "dash": [],
                    i18n: v => v ? this.$t('On') : this.$t('Off')
                })
            }
            return rtn;
        }
    },
    watch: {
        value: {
            deep: true,
            handler () { if (this.$refs.plot) this.$refs.plot.redraw(this.plotData); }
        }
    }
}
</script>